var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "box-top" },
          _vm._l(_vm.dataTitlelist, function (item, index) {
            return _c("div", { key: item, staticClass: "box-box" }, [
              _c("img", {
                staticClass: "box-img",
                attrs: {
                  src: require("@/assets/imgs/dash-" + index + ".png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box-text-bootn" },
                [
                  _c("span", { staticClass: "box-text-chine" }, [
                    _vm._v(_vm._s(item.name)),
                  ]),
                  _vm._v(" "),
                  _c("countTo", {
                    staticClass: "box-text-num",
                    attrs: {
                      startVal: 0,
                      endVal: Number(item.value),
                      duration: 2000,
                    },
                  }),
                ],
                1
              ),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "box-echarts-right" },
          _vm._l(_vm.dataRight, function (item, index) {
            return _c("div", { key: index, staticClass: "box-eachar-data" }, [
              _c("div", { staticClass: "box-img-data" }, [
                _c("img", {
                  staticClass: "box-img-data",
                  attrs: {
                    src: require("@/assets/imgs/dash-" + index + ".png"),
                    alt: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box-text-bootn-data" },
                [
                  _c("span", { staticClass: "box-text-chine-data" }, [
                    _vm._v(_vm._s(item.name)),
                  ]),
                  _vm._v(" "),
                  _c("countTo", {
                    staticClass: "box-text-num-data",
                    attrs: {
                      startVal: 0,
                      endVal: Number(item.value),
                      duration: 2000,
                    },
                  }),
                ],
                1
              ),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "box-eaharts" }, [
          _c(
            "div",
            { staticClass: "box-echarts-title" },
            [
              _c("div", { staticClass: "box-title" }, [_vm._v("交易数据")]),
              _vm._v(" "),
              _c("div", { staticClass: "box-text" }, [
                _vm._v("X轴为时间,Y轴为金额"),
              ]),
              _vm._v(" "),
              _c("echartsFrom", {
                staticClass: "box-echarts-left",
                attrs: {
                  yAxisData: _vm.yAxis,
                  seriesData: _vm.series,
                  xAxis: _vm.xAxis,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }